var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('span',{staticClass:"disabled"},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.name)+"\n")]):(_vm.active)?_c('span',{staticClass:"active",on:{"click":_vm.action}},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.name)+"\n")]):_c('span',{class:_vm.colorHover,on:{"click":_vm.action}},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }